import { useState, useEffect } from "react";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { toast } from "sonner";

export default function AdminSEOTab({ apiUrl, getAuthHeaders }) {
  const credFetch = (url, opts = {}) => fetch(url, { ...opts, credentials: "include" });

  const [seoSettings, setSeoSettings] = useState({
    site_title: "", site_description: "", site_keywords: "", og_image: "", twitter_handle: "", google_analytics_id: "", google_search_console: "",
  });

  useEffect(() => { loadSeoSettings(); }, []);

  const loadSeoSettings = async () => {
    try {
      const res = await credFetch(`${apiUrl}/api/admin/settings/seo`, { headers: getAuthHeaders(), credentials: "include" });
      const data = await res.json();
      if (data.success) setSeoSettings(data.settings);
    } catch (error) { console.error("SEO settings error:", error); }
  };

  const saveSeoSettings = async () => {
    try {
      const res = await credFetch(`${apiUrl}/api/admin/settings/seo`, { method: "PUT", headers: getAuthHeaders(), credentials: "include", body: JSON.stringify(seoSettings) });
      if (res.ok) toast.success("SEO settings saved");
    } catch (error) { toast.error("Save failed"); }
  };

  return (
    <div className="space-y-6" data-testid="admin-seo-tab">
      <h2 className="text-2xl font-bold text-gray-900">SEO Settings</h2>
      <Card className="p-6">
        <div className="space-y-4">
          <div><label className="text-sm font-medium">Site Title</label><Input value={seoSettings.site_title} onChange={(e) => setSeoSettings({ ...seoSettings, site_title: e.target.value })} placeholder="MarkeeMix - AI Workspace for Teachers, Creators & Marketers" /></div>
          <div><label className="text-sm font-medium">Site Description</label><Textarea value={seoSettings.site_description} onChange={(e) => setSeoSettings({ ...seoSettings, site_description: e.target.value })} placeholder="75+ AI tools built for teachers, creators, and marketers..." rows={3} /></div>
          <div><label className="text-sm font-medium">Keywords</label><Input value={seoSettings.site_keywords} onChange={(e) => setSeoSettings({ ...seoSettings, site_keywords: e.target.value })} placeholder="SEO tools, digital marketing, content marketing" /></div>
          <div><label className="text-sm font-medium">OG Image URL</label><Input value={seoSettings.og_image} onChange={(e) => setSeoSettings({ ...seoSettings, og_image: e.target.value })} placeholder="https://markeemix.com/og-image.png" /></div>
          <div className="grid grid-cols-2 gap-4">
            <div><label className="text-sm font-medium">Twitter Handle</label><Input value={seoSettings.twitter_handle} onChange={(e) => setSeoSettings({ ...seoSettings, twitter_handle: e.target.value })} placeholder="@markeemix" /></div>
            <div><label className="text-sm font-medium">Google Analytics ID</label><Input value={seoSettings.google_analytics_id} onChange={(e) => setSeoSettings({ ...seoSettings, google_analytics_id: e.target.value })} placeholder="G-XXXXXXXXXX" /></div>
          </div>
          <div><label className="text-sm font-medium">Google Search Console</label><Input value={seoSettings.google_search_console} onChange={(e) => setSeoSettings({ ...seoSettings, google_search_console: e.target.value })} placeholder="Verification code" /></div>
          <Button onClick={saveSeoSettings} className="bg-violet-600 hover:bg-violet-700">Save SEO Settings</Button>
        </div>
      </Card>
    </div>
  );
}
